import React from 'react';
import { Wrench, Clock, Shield } from 'lucide-react';

/**
 * Компонент для параметров обслуживания и поддержки AR-проекта
 */
const MaintenanceOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  maintenanceLevels
}) => {
  if (!formData.includeMaintenancePlan) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <label className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="includeMaintenancePlan"
            checked={formData.includeMaintenancePlan}
            onChange={handleInputChange}
            className="form-checkbox mr-2"
          />
          <Wrench className="w-4 h-4 mr-2 text-indigo-500" />
          <span>
            Включить план поддержки и обслуживания
          </span>
        </label>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-7">
          Рекомендуется для обеспечения бесперебойной работы AR-решения и обновления функций в будущем
        </p>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Wrench className="w-5 h-5 mr-2 text-amber-500" />
        Поддержка и обслуживание
      </h3>

      <div className="flex items-center mb-4">
        <label className="flex items-center text-sm font-medium text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            name="includeMaintenancePlan"
            checked={formData.includeMaintenancePlan}
            onChange={handleInputChange}
            className="form-checkbox mr-2"
          />
          <span>
            Включить план поддержки и обслуживания
          </span>
        </label>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Уровень обслуживания */}
        <div>
          <label htmlFor="maintenanceLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Shield className="w-4 h-4 mr-2 text-amber-500" />
            Уровень обслуживания
          </label>
          <select
            id="maintenanceLevel"
            name="maintenanceLevel"
            value={formData.maintenanceLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.maintenanceLevel ? 'input-error' : ''}`}
          >
            {maintenanceLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name} - {level.description}
              </option>
            ))}
          </select>
          {errors.maintenanceLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenanceLevel}
            </p>
          )}
        </div>

        {/* Срок обслуживания */}
        <div>
          <label htmlFor="maintenanceDuration" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-amber-500" />
            Срок обслуживания (месяцев)
          </label>
          <input
            type="number"
            id="maintenanceDuration"
            name="maintenanceDuration"
            value={formData.maintenanceDuration}
            onChange={handleInputChange}
            min="1"
            max="60"
            className={`form-input w-full ${errors.maintenanceDuration ? 'input-error' : ''}`}
            placeholder="Введите срок"
          />
          {errors.maintenanceDuration && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.maintenanceDuration}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <div className="flex items-start">
          <Shield className="w-5 h-5 text-amber-600 dark:text-amber-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-amber-700 dark:text-amber-300 mb-1">
              Почему нужно обслуживание AR-проекта
            </h4>
            <p className="text-xs text-amber-600 dark:text-amber-400">
              AR-технологии быстро развиваются и требуют регулярных обновлений. План поддержки обеспечивает 
              совместимость с новыми версиями операционных систем, обновление контента и устранение ошибок. 
              Премиум-уровни поддержки также включают разработку новых функций и оптимизацию производительности.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceOptionsSection;